"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const OsmosysProvider_1 = require("./OsmosysProvider");
const App_1 = require("./App");
exports.OsmosysUi = ({ development }) => {
    react_1.useMemo(() => {
        if (development) {
            if (!window.location.host.startsWith('127.0.0.1') &&
                !window.location.host.includes('ngrok')) {
                window.location.href = 'http://127.0.0.1:9000';
            }
        }
    }, [development]);
    return (react_1.default.createElement(OsmosysProvider_1.OsmosysProvider, null,
        react_1.default.createElement(App_1.App, null)));
};
//# sourceMappingURL=index.js.map